export default __webpack_public_path__ + "media/images/transfer-progress-upsell-412f44b1.png";